module.exports = __webpack_public_path__ + "24870ef768edc04b272492609e5ba9d1.png";